import api from './axiosConfig';

export interface DashboardUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface CurrentStay {
  booking: {
    id: string;
    check_in: string;
    check_out: string;
    total_amount: number;
    status: string;
    botel: {
      name: string;
      location: string;
      location_address: string;
    };
  };
  daysUntilCheckIn: number;
  hoursUntilCheckIn: number;
  minutesUntilCheckIn: number;
}

export interface BookingHistoryItem {
  id: string;
  botelName: string;
  location: string;
  checkIn: string;
  checkOut: string;
  status: string;
  totalAmount: number;
  rating?: number;
  review?: string;
}

export interface DashboardStats {
  totalStays: number;
  totalStaysThisYear: number;
  averageRating: number;
  loyaltyPoints: number;
  loyaltyTier: string;
  pointsToNextTier: number;
}

export interface UserReview {
  id: string;
  botelName: string;
  rating: number;
  review: string;
  date: string;
}

export interface DashboardData {
  user: DashboardUser;
  currentStay: CurrentStay | null;
  bookingHistory: BookingHistoryItem[];
  stats: DashboardStats;
  reviews: UserReview[];
}

export const dashboardService = {
  async getDashboardData(): Promise<DashboardData> {
    try {
      const response = await api.get('/user/dashboard');
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
      throw error;
    }
  }
}; 